module.exports = __webpack_public_path__ + "static/media/time.e20e8a76.svg";